@if (isOpen()) {
  <kendo-dialog
    title="{{ 'summarization.timeline.title' | translate }} - {{ entryName() }}"
    (close)="close()"
    [width]="800"
    maxWidth="90%"
    height="95%"
    [style.z-index]="'.k-window, .ui-dialog' | maxZIndex: 99990"
    [maxHeight]="900"
  >
    <div class="flex flex-col h-full gap-2">
      <p class="text-body-1">
        {{ 'summarization.timeline.subtitle' | translate }}
      </p>
      <div class="filter-panel max-overflow-x max-thin-scrollbar-container">
        <div class="flex flex-nowrap flex-grow justify-between">
          <div class="pt-2 px-2">
            <kendo-label
              class="text-caption flex flex-col"
              [text]="'summarization.dateRange' | translate"
            >
              <kendo-dropdownlist
                #dueDateSelector
                valueField="id"
                textField="name"
                [data]="dueDates()"
                [(ngModel)]="selectedDueDate"
                class="h-8.5 mt-0.5"
                style="min-width: 280px; max-width: 350px"
                [listHeight]="500"
                [focusOnViewInit]="true"
                (selectionChange)="
                  tracker.trackEvent(eventJourney.Action, eventAction.Clicked, {
                    name: 'change-date-range',
                    dueDate: $event.id,
                  })
                "
              >
                <ng-template
                  kendoDropDownListItemTemplate
                  kendoDropDownListValueTemplate
                  let-item
                >
                  {{
                    item?.translationID | translate
                  }}
                </ng-template>
              </kendo-dropdownlist>
            </kendo-label>
          </div>

          <div class="pt-2 px-2">
            <kendo-label class="text-caption flex flex-col">
              <button
                kendoButton
                themeColor="primary"
                rounded="large"
                class="h-8.5 mt-0.5"
                (click)="addSubscription(summarize().subscribe())"
              >
                {{ 'summarization.summarize' | translate }}
              </button>
            </kendo-label>
          </div>
        </div>
      </div>

      <kendo-tabstrip
        class="overflow-hidden flex-grow"
        (tabSelect)="
          tracker.trackEvent(eventJourney.Action, eventAction.Clicked, {
            name:
              $event.index === 1
                ? 'switch-to-recommended-actions'
                : 'switch-to-summarization',
          })
        "
      >
        <kendo-tabstrip-tab
          #summarizationTab
          id="summarization"
          [title]="'summarization.tabs.summarization' | translate"
          [selected]="true"
        >
          <ng-template kendoTabContent>
            <div class="py-2 flex flex-col items-center justify-center h-full">
              @if (summaryText().length) {
                <div
                  class="flex-grow w-full max-h-full overflow-y-auto text-body-2 border border-neutral-40 p-2"
                  [innerHTML]="summaryText() | deAnonymizer | safeHtml"
                ></div>
              } @else if (!loading()) {
                <img
                  class="w-[108px]"
                  [src]="cdn + '/assets/images/empty-container.svg'"
                  [alt]="message.innerText"
                />
                <span #message class="text-caption mt-4">
                  @if (summary() === undefined) {
                    {{
                      'summarization.message.pressToSummarize' | translate
                    }}
                  } @else {
                    {{ 'summarization.message.noSummary' | translate }}
                  }
                </span>
              }
            </div>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab
          id="recommendedActions"
          [title]="'summarization.tabs.recommendedActions' | translate"
        >
          <ng-template kendoTabContent>
            <div class="py-2 flex flex-col items-center justify-center h-full">
              @if (summary()?.recommendations?.length) {
                <kendo-listview
                  class="flex-grow w-full"
                  [data]="summary()?.recommendations ?? []"
                >
                  <ng-template
                    kendoListViewItemTemplate
                    let-item
                    let-index="index"
                  >
                    <div
                      class="flex border border-solid border-neutral-25 mb-2 mx-2 p-4 gap-4 k-item"
                      [ngClass]="{ 'mt-2': index === 0 }"
                    >
                      <span
                        class="text-neutral-70"
                        [ngClass]="actions[item.type].icon"
                      ></span>
                      <div class="flex flex-col flex-grow">
                        <span
                          class="subtitle-2"
                          [innerHTML]="item.title | deAnonymizer | safeHtml"
                        ></span>
                        <span
                          class="mt-1 text-body-2"
                          [innerHTML]="item.content | deAnonymizer | safeHtml"
                        ></span>
                        <span class="mt-2 text-right">
                          <button
                            kendoButton
                            themeColor="primary"
                            fillMode="flat"
                            [iconClass]="actions[item.type].icon + ' icon-16'"
                            (click)="add(actions[item.type])"
                          >
                            {{
                              actions[item.type].translation.translationID | translate | replace: '...' : ''
                            }}
                          </button>
                        </span>
                      </div>
                    </div>
                  </ng-template>
                </kendo-listview>
              } @else {
                <img
                  class="w-[108px]"
                  [src]="cdn + '/assets/images/empty-container.svg'"
                  [alt]="message.innerText"
                />
                <span #message class="text-caption mt-4">
                  @if (summary() === undefined) {
                    {{
                      'summarization.message.pleaseSummarize' | translate
                    }}
                  } @else {
                    {{
                      'summarization.message.noRecommendedActions' | translate
                    }}
                  }
                </span>
              }
            </div>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    </div>
    @if (loading()) {
      <maximizer-loader type="legacy"></maximizer-loader>
    }
    <kendo-dialog-actions class="mt-2 justify-between">
      <div class="flex items-center justify-between">
        <div>
          @if (summarizationTab.selected) {
            <button
              kendoButton
              themeColor="primary"
              fillMode="flat"
              (click)="copyToClipboard()"
              [disabled]="!summary()"
            >
              <div class="flex items-center">
                <span class="fa-icons icon-light icon-16 icon-copy mr-1"></span>
                {{ 'buttons.copyToClipboard' | translate }}
              </div>
            </button>
          }
        </div>
        <div class="flex flex-row gap-4">
          @if (!loading() && summary()) {
            <ai-feedback
              [disableOnFeedback]="true"
              [source]="tracker.module"
              [label]="'summarization.feedback' | translate"
            ></ai-feedback>
          }
          <button
            kendoButton
            themeColor="secondary"
            (click)="close()"
            class="uppercase"
          >
            {{ 'buttons.close' | translate }}
          </button>
        </div>
      </div>
    </kendo-dialog-actions>
  </kendo-dialog>
}
